import React from 'react';
import PropTypes from 'prop-types';

import connect from 'app/libs/connect';
import S from 'app/features/landing/productComparison/components/Product/Buttons/Buttons.styled';
import {
  isFreeProduct,
  isEligibleToSkipFreeTrial,
} from 'app/features/products/selectors';
import FreeProductButton from 'app/features/landing/productComparison/components/Product/Buttons/FreeProductButton';
import PaidProductButton from 'app/features/landing/productComparison/components/Product/Buttons/PaidProductButton';
import SkipFreeTrialCta from 'app/features/landing/productComparison/components/Product/Cta/SkipFreeTrialCta';

const UI = ({ isFreeProduct, sku, isEligibleToSkipFreeTrial }) => (
  <S.Buttons
    isEligibleToSkipFreeTrial={isEligibleToSkipFreeTrial}
    isFree={isFreeProduct}
  >
    {isFreeProduct ? <FreeProductButton /> : <PaidProductButton sku={sku} />}
    {isEligibleToSkipFreeTrial && <SkipFreeTrialCta sku={sku} />}
  </S.Buttons>
);

UI.propTypes = {
  sku: PropTypes.string.isRequired,
  isFreeProduct: PropTypes.bool,
  isEligibleToSkipFreeTrial: PropTypes.bool,
};

UI.defaultProps = {
  isFreeProduct: false,
  isEligibleToSkipFreeTrial: false,
};

UI.displayName = 'Button';

const Buttons = connect({ isFreeProduct, isEligibleToSkipFreeTrial })(UI);

export { UI };

export default Buttons;
